import "core-js/modules/esnext.global-this.js";
// packages/react/use-escape-keydown/src/use-escape-keydown.tsx
import * as React from "react";
import { useCallbackRef } from "@radix-ui/react-use-callback-ref";
function useEscapeKeydown(onEscapeKeyDownProp) {
  var ownerDocument = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
  var onEscapeKeyDown = useCallbackRef(onEscapeKeyDownProp);
  React.useEffect(function () {
    var handleKeyDown = function handleKeyDown(event) {
      if (event.key === "Escape") {
        onEscapeKeyDown(event);
      }
    };
    ownerDocument.addEventListener("keydown", handleKeyDown, {
      capture: true
    });
    return function () {
      return ownerDocument.removeEventListener("keydown", handleKeyDown, {
        capture: true
      });
    };
  }, [onEscapeKeyDown, ownerDocument]);
}
export { useEscapeKeydown };